import { Component, Vue } from "vue-property-decorator";

const COMPANY_ROLES = ["FOUR_NETWORK", "MARKETING"];

export const getLoginRouteFromRole = (role?: string): string => {
  return role && COMPANY_ROLES.includes(role)
    ? "loginCompanyPage"
    : "loginUserPage";
};

@Component
export class LogoutMixin extends Vue {
  get loginRoute(): string {
    return getLoginRouteFromRole(this.$store?.state?.profile?.me?.role);
  }

  redirectToLogin(): void {
    this.$router.push({ name: this.loginRoute });
  }
}
